import React, { useState } from "react";
import { toast } from "react-toastify";

import ModalSkeleton from "./ModalSkeleton";

const AddAndEditLessonModal = ({
  open,
  setOpen,
  data,
  isLoading,
  handleSubmit,
}) => {
  // states
  const [lessonName, setLessonName] = useState(data?.lessonName || "");

  //   btnClickHandler
  const btnClickHandler = (e) => {
    e.preventDefault();
    const params = {
      lessonName,
    };

    // validate
    if (params.lessonName === "") return toast.warn(`Lesson Name is required`);

    handleSubmit(params);
  };

  return (
    <ModalSkeleton open={open} setOpen={setOpen}>
      <form className="login100-form validate-form">
        <span className="login100-form-title text-left text-color pb-4">
          {data ? "Edit" : "Add"} Lesson
        </span>

        {/* lessonName */}
        <div>
          <label>Lesson Name</label>
          <input
            className="add-evidence-modal-input full"
            type="text"
            placeholder="Lesson Name Here"
            value={lessonName}
            onChange={(e) => {
              setLessonName(e.target.value);
            }}
          />
        </div>

        {/* btn */}
        <div className="container-login100-form-btn mt-4">
          <div className="wrap-login100-form-btn">
            <div className="login100-form-bgbtn"></div>
            <button
              disabled={isLoading}
              className="login100-form-btn"
              onClick={btnClickHandler}
            >
              {isLoading ? "Please Wait..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </ModalSkeleton>
  );
};

export default AddAndEditLessonModal;
